import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import "@/components/avatar";
import "@/components/button";
import EkoElement from "@/utilities/element";
import style from "./command-menu-avatar.css?inline";

@customElement("eko-command-menu-avatar")
export class CommandMenuAvatar extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) alt?: string;
  @property({ reflect: true }) initials?: string;
  @property({ reflect: true }) src?: string;

  render() {
    return html`
      <eko-button square part="button">
        <eko-avatar
          alt=${ifDefined(this.alt)}
          initials=${ifDefined(this.initials)}
          src=${ifDefined(this.src)}
          variant="square"
          part="avatar">
        </eko-avatar>
      </eko-button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-command-menu-avatar": CommandMenuAvatar;
  }
}

export default CommandMenuAvatar;
